import { useWorkloadOptimizationAgentStatus } from 'features/workload-optimization';

export const useIsPsiEnabled = () => {
  return !!useWorkloadOptimizationAgentStatus().psiMetricsSupported;
};
